<template>
<div class="chapter">
<div class="inner_page">
<h2 class="section_title"><a id="page_14"></a><a id="page_15"></a><a id="ch1"></a>CHAPTER 1</h2>
<h2 class="section_hd">LARDER</h2>
<div class="wrap">
<p class="image"><img alt="image" class="vertical" src="images/f0014-01.jpg"/></p>
</div>
<p class="chtoc"><a href="#/xhtml/09chapter02#pg17lev1"><em>Preserved kumquats with lime and chile</em></a> <a href="#/xhtml/09chapter02#pg17lev1"><span class="font1">17</span></a></p>
<p class="chtoc"><a href="#/xhtml/10chapter03#pg18lev1"><em>Preserved kumquat vinaigrette</em></a> <a href="#/xhtml/10chapter03#pg18lev1"><span class="font1">18</span></a></p>
<p class="chtoc"><a href="#/xhtml/11chapter04#pg21lev1"><em>Hoja santa vinaigrette</em></a> <a href="#/xhtml/11chapter04#pg21lev1"><span class="font1">21</span></a></p>
<p class="chtoc"><a href="#/xhtml/12chapter05#pg22lev1"><em>Cascabel-thyme vinaigrette</em></a> <a href="#/xhtml/12chapter05#pg22lev1"><span class="font1">22</span></a></p>
<p class="chtoc"><a href="#/xhtml/13chapter06#pg23lev1"><em>Carrot escabeche</em></a> <a href="#/xhtml/13chapter06#pg23lev1"><span class="font1">23</span></a></p>
<p class="chtoc"><a href="#/xhtml/14chapter07#pg24lev1"><em>Habanero pickle</em></a> <a href="#/xhtml/14chapter07#pg24lev1"><span class="font1">24</span></a></p>
<p class="chtoc"><a href="#/xhtml/15chapter08#pg25lev1"><em>Pickled oregano onions</em></a> <a href="#/xhtml/15chapter08#pg25lev1"><span class="font1">25</span></a></p>
<p class="chtoc"><a href="#/xhtml/16chapter09#pg27lev1"><em>Pickled gooseberries</em></a> <a href="#/xhtml/16chapter09#pg27lev1"><span class="font1">27</span></a></p>
<p class="chtoc"><a href="#/xhtml/17chapter10#pg28lev1"><em>Mexican salmorejo</em></a> <a href="#/xhtml/17chapter10#pg28lev1"><span class="font1">28</span></a></p>
<p class="chtoc"><a href="#/xhtml/18chapter11#pg29lev1"><em>Mexican sriracha</em></a> <a href="#/xhtml/18chapter11#pg29lev1"><span class="font1">29</span></a></p>
<p class="chtoc"><a href="#/xhtml/19chapter12#pg31lev1"><em>Morita-guajillo salsa</em></a> <a href="#/xhtml/19chapter12#pg31lev1"><span class="font1">31</span></a></p>
<p class="chtoc"><a href="#/xhtml/20chapter13#pg32lev1"><em>Amá spice mix</em></a> <a href="#/xhtml/20chapter13#pg32lev1"><span class="font1">32</span></a></p>
<p class="chtoc"><a href="#/xhtml/21chapter14#pg34lev1"><em>Soldadera’s hot sauce</em></a> <a href="#/xhtml/21chapter14#pg34lev1"><span class="font1">34</span></a></p>
<p class="chtoc"><a href="#/xhtml/22chapter15#pg35lev1"><em>Jesusita’s pequín salsa</em></a> <a href="#/xhtml/22chapter15#pg35lev1"><span class="font1">35</span></a></p>
<p class="chtoc"><a href="#/xhtml/23chapter16#pg36lev1"><em>Red-eye spice</em></a> <a href="#/xhtml/23chapter16#pg36lev1"><span class="font1">36</span></a></p>
<p class="chtoc"><a href="#/xhtml/24chapter17#pg37lev1"><em>Salsa de aguacate</em></a> <a href="#/xhtml/24chapter17#pg37lev1"><span class="font1">37</span></a></p>
<p class="chtoc"><a href="#/xhtml/25chapter18#pg38lev1"><em>Pine nut and tepin salsa</em></a> <a href="#/xhtml/25chapter18#pg38lev1"><span class="font1">38</span></a></p>
<p class="chtoc"><a href="#/xhtml/26chapter19#pg41lev1"><em>Cobjini</em></a> <a href="#/xhtml/26chapter19#pg41lev1"><span class="font1">41</span></a></p>
<p class="chtoc"><a href="#/xhtml/27chapter20#pg43lev1"><em>Tomatillo salsa</em></a> <a href="#/xhtml/27chapter20#pg43lev1"><span class="font1">43</span></a></p>
<p class="chtoc"><a href="#/xhtml/28chapter21#pg44lev1"><em>Charred green-onion crema</em></a> <a href="#/xhtml/28chapter21#pg44lev1"><span class="font1">44</span></a></p>
<p class="chtoc"><a href="#/xhtml/29chapter22#pg47lev1"><em>Cascabel pimento cheese</em></a> <a href="#/xhtml/29chapter22#pg47lev1"><span class="font1">47</span></a></p>
<div class="wrap">
<p class="image"><img alt="image" class="vertical" src="images/f0015-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08-chapter01.vue?eb5b7ace